import { useTranslation } from 'react-i18next';
import { Head } from '@/components/seo/Head/Head';
import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { ForgotPasswordSteps } from '@/features/auth/components/ForgotPasswordSteps/ForgotPasswordSteps';

export const ForgotPasswordRoute = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotPassword' });

  return (
    <>
      <Head title={t('seo.title')} />
      <GenericLayout>
        <ForgotPasswordSteps />
      </GenericLayout>
    </>
  );
};
